'use strict';

angular.module('imagetrend.components')
    .directive('flashMessage', [function () {
        return {
            restrict: 'AE',
            scope: {
                classes: '@?'
            },
            transclude: true,
            replace: true,
            templateUrl: 'templates/flash-message/flash-message.html',
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;